export default __webpack_public_path__ + "static/media/WordWork_01.6b22a4b7.png";